module.exports = __webpack_public_path__ + "static/reportOutage_res-16f15795435d27ab73257188eaa01c4d.png";